import { useCallback } from 'react';

import { useClient } from '../../../services/apollo';
import staticDataQuery from '../staticData.graphql';

import type { StaticDataQueryVariables, StaticDataQuery } from '../../types';

export function useFetchStaticData() {
  const apolloClient = useClient();

  const fetchStaticData = useCallback(() => {
    return apolloClient.query<StaticDataQuery, StaticDataQueryVariables>({
      query: staticDataQuery,
    });
  }, [apolloClient]);

  return fetchStaticData;
}
